export function definedItems<T>(array: (T | undefined)[] | undefined): T[] | undefined {
  return array?.filter((x): x is T => x !== undefined)
}
